const getMRVPrintTemplate = (data) => {

  const formatDateDMY = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
  };

  const reportData = data?.items || [];

  // ✅ ADD THIS LINE (FIX)
  const firstItem = reportData?.[0] || {};

  return `
<html>
<head>
<meta charset="utf-8"/>
<title>MRV</title>
</head>

<body style="background-color:#f7fafc; padding:16px;">
<div style="max-width:1024px; margin:0 auto; background:white; padding:24px; box-shadow:0 4px 6px rgba(0,0,0,0.1);">

<!-- HEADER -->
<div style="margin-bottom:16px;">

  <div style="display:flex; justify-content:space-between; align-items:flex-start;">
    <div>
      <h1 style="font-size:1.25rem; font-weight:bold; margin:0;">
        Indigo Infraprojects Pvt. Ltd.
      </h1>
      <p style="font-size:0.85rem; margin:2px 0;">
        3rd Floor, Plot No. - 12/B, Pocket 3, Sector - 17
      </p>
      <p style="font-size:0.85rem; margin:2px 0;">
        Dwarka, New Delhi - 110075
      </p>
    </div>

    <img src="https://indigoinfra.in/img/product/product-1739471679615.jpeg" width="110"/>
  </div>

  <div style="text-align:center; margin-top:10px;">
    <h2 style="font-weight:bold; text-transform:uppercase;">
      Material Receipt Voucher (Digital Copy)
    </h2>
  </div>
</div>

<!-- DETAILS -->
<div style="display:flex; justify-content:space-between; margin-bottom:16px; font-size:14px;">
  <div>
    <p>MRV No : <strong>${data.mrvNo || "-"}</strong></p>
    <p>Supplier : ${data.supplier?.name || "-"}</p>
    <p>Bill No : ${data.billingNo || "-"}</p>
    <p>Bill Date : ${formatDateDMY(data.billingDate)}</p>
    <p>Status : <strong>${data.status || "-"}</strong></p>
  </div>

  <div>
  <p>Project Code : ${data.store?.storeCode || "-"}</p>

  <p>
    Project Name : ${String(data.store?.name || "-").toUpperCase()}
  </p>

  <p>
    Location : <strong>
      ${String(data.store?.location || "-").toUpperCase()}
    </strong>
  </p>

  <p>
    Date : <strong>${formatDateDMY(data.createdAt)}</strong>
  </p>
</div>
</div>

<!-- TABLE -->
<table
  style="
    width:100%;
    border-collapse:collapse;
    border:1px solid #cbd5e0;
    margin-bottom:16px;
    font-size:11px;
    line-height:1.35;
    text-align:left;
  "
>
<thead>
  <tr>

    <th
      style="
        border:1px solid #cbd5e0;
        padding:8px;
        font-weight:700;
      "
    >
      S.No
    </th>

    <th
      style="
        border:1px solid #cbd5e0;
        padding:8px;
        font-weight:700;
      "
    >
      Part No
    </th>

    <th
      style="
        border:1px solid #cbd5e0;
        padding:8px;
        font-weight:700;
      "
    >
      Description
    </th>

    <th
      style="
        border:1px solid #cbd5e0;
        padding:8px;
        font-weight:700;
      "
    >
      Unit
    </th>

    <th
      style="
        border:1px solid #cbd5e0;
        padding:8px;
        font-weight:700;
      "
    >
      Req Qty
    </th>

    <th
      style="
        border:1px solid #cbd5e0;
        padding:8px;
        font-weight:700;
      "
    >
      Appr Qty
    </th>

    <th
      style="
        border:1px solid #cbd5e0;
        padding:8px;
        font-weight:700;
      "
    >
      Received Qty
    </th>

    <th
      style="
        border:1px solid #cbd5e0;
        padding:8px;
        font-weight:700;
      "
    >
      Damage Qty
    </th>

    <th
      style="
        border:1px solid #cbd5e0;
        padding:8px;
        font-weight:700;
      "
    >
      Mode
    </th>

    <th
      style="
        border:1px solid #cbd5e0;
        padding:8px;
        font-weight:700;
      "
    >
      Status
    </th>

    <th
      style="
        border:1px solid #cbd5e0;
        padding:8px;
        font-weight:700;
        min-width:140px;
      "
    >
      Store Remark
    </th>

  </tr>
</thead>

<tbody>
${reportData && reportData.length > 0
      ? reportData.map((item, i) => `
<tr>
  <td style="border:1px solid #cbd5e0; padding:8px;">${i + 1}</td>
  <td
  style="
    border:1px solid #cbd5e0;
    padding:8px;
    white-space:nowrap;
  "
>
  ${item?.partNo || "-"}
</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.description || "-"}</td>
  <td
  style="
    border:1px solid #cbd5e0;
    padding:8px;
    white-space:nowrap;
  "
>
  ${String(item?.unit || "-").toUpperCase()}
</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.qtyRequired || 0}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.approveQty || 0}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">
  <div>
    ${item?.qtyRecived ?? 0}
  </div>

  <div
    style="
      font-size:9px;
      margin-top:3px;
      font-weight:600;
      white-space:nowrap;
    "
  >
    (Flag: ${String(item?.flag || "new").toUpperCase()})
  </div>
</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.damageQty || 0}</td>
<td
  style="
    border:1px solid #cbd5e0;
    padding:8px;
    white-space:nowrap;
  "
>
  ${(() => {

          const supplierName =
            String(data?.supplier?.name || "")
              .trim()
              .toUpperCase();

          const poNumber =
            item?.poDetails?.poNumber ||
            item?.poNumber ||
            null;

          if (supplierName.startsWith("LOCAL")) {
            return "LOCAL";
          }

          if (
            poNumber &&
            poNumber !== "-"
          ) {
            return poNumber;
          }

          return "PO";

        })()}
</td>
<td
  style="
    border:1px solid #cbd5e0;
    padding:8px;
    white-space:nowrap;
  "
>
  ${String(
          item?.status === "recived"
            ? "RECEIVED"
            : item?.status || "-"
        ).toUpperCase()
        }
</td>

<td
  style="
    border:1px solid #cbd5e0;
    padding:8px;
    white-space:normal;
    word-break:break-word;
    min-width:140px;
  "
>
  ${String(item?.storeRemark || item?.remark || "-").toUpperCase()}
</td>
</tr>
`).join("")
      : `
<tr>
 <td colspan="11" style="border:1px solid #cbd5e0; padding:10px; text-align:center;">
    No Items Found
  </td>
</tr>
`
    }
</tbody>
</table>

<!-- FOOTER -->
<div style="margin-top:32px; font-size:14px;">

  <div
    style="
      display:flex;
      justify-content:space-between;
      align-items:flex-start;
    "
  >

    <!-- LEFT : STORE KEEPER -->
    <div style="width:33%; text-align:left;">

      <div>
        Prepared By&nbsp;:&nbsp;
        <strong>
          ${data?.user?.name
      ? String(data.user.name).toUpperCase()
      : "__________"
    }
        </strong>
      </div>

      <div style="margin-top:4px;">
        (Store Keeper)
      </div>

      <div style="margin-top:4px;">
        Date&nbsp;:&nbsp;
        <strong>
          ${data?.createdAt
      ? formatDateDMY(data.createdAt)
      : "__________"
    }
        </strong>
      </div>

    </div>


    <!-- CENTER : PROJECT MANAGER -->
    <div style="width:33%; text-align:center;">

      <div>
        Approved By&nbsp;:&nbsp;
        <strong>
          ${firstItem?.approvedByAdmin
      ? String(
        firstItem.approvedByAdmin?.name ||
        firstItem.approvedByAdmin
      ).toUpperCase()
      : "__________"
    }
        </strong>
      </div>

      <div style="margin-top:4px;">
        (Project Manager)
      </div>

      <div style="margin-top:4px;">
        Date&nbsp;:&nbsp;
        <strong>
          ${firstItem?.approvedByAdminAt
      ? formatDateDMY(firstItem.approvedByAdminAt)
      : "__________"
    }
        </strong>
      </div>

    </div>


    <!-- RIGHT : CENTRAL TEAM -->
    <div style="width:33%; text-align:right;">

      <div>
        Approved By&nbsp;:&nbsp;
        <strong>
          ${firstItem?.approvedBySuperAdmin
      ? String(
        firstItem.approvedBySuperAdmin?.name ||
        firstItem.approvedBySuperAdmin
      ).toUpperCase()
      : "__________"
    }
        </strong>
      </div>

      <div style="margin-top:4px;">
        (Central Team)
      </div>

      <div style="margin-top:4px;">
        Date&nbsp;:&nbsp;
        <strong>
          ${firstItem?.approvedBySuperAdminAt
      ? formatDateDMY(firstItem.approvedBySuperAdminAt)
      : "__________"
    }
        </strong>
      </div>

    </div>

  </div>

</div>

</div>
</body>
</html>
`;
};

export default getMRVPrintTemplate;